// src/store/useCreditStore.js
import { create } from "zustand";
import axios from "axios";

export const useCreditStore = create((set) => ({
  credits: 0,
  loading: false,
  error: null,

  setCredits: (n) => set({ credits: typeof n === "number" ? n : 0 }),
  addCredits: (n = 1) => set((s) => ({ credits: Math.max(0, s.credits + n) })),
  deductCredits: (n = 1) =>
    set((s) => ({ credits: Math.max(0, s.credits - n) })),

  /**
   * Refresh credits from backend
   * Pass a getToken fn from Clerk: refreshCredits(getToken)
   */
  refreshCredits: async (getToken) => {
    try {
      set({ loading: true, error: null });
      const token = getToken ? await getToken() : null;

      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/credits/balance`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          withCredentials: true,
        }
      );

      const value =
        res?.data?.balance ??
        res?.data?.credits ?? // fallback if API ever returns `credits`
        0;

      set({ credits: value, loading: false });
      return value;
    } catch (err) {
      console.error("refreshCredits error:", err);
      set({
        error: err?.response?.data?.error || err?.message || "Failed to load credits",
        loading: false,
      });
      return null;
    }
  },
}));
